import type {ContentState, ContentBlock} from 'draft-js';

export const findLinkEntities = (contentBlock: ContentBlock, callback, contentState: ContentState) => {
    contentBlock.findEntityRanges(character => {
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
};
